<common-card>
  <common-card-header>
    <h3>{{'modules.mission.mission_form.contact_dialog.edit_contact' | translate}}</h3>
  </common-card-header>
  <common-card-body>
    <div class="d-flex align-items-center">
      <label class="mb-0 mr-2">{{'modules.mission.mission_form.contact_dialog.civility' | translate}}</label>
<!--      <input nbInput class="mr-2" [(ngModel)]="title">-->
      <nb-select [(ngModel)]="title" class="mr-2">
        <nb-option *ngFor="let type of (availableTitles | async)"
                   [value]="type.value">
          {{type.name}}
        </nb-option>
      </nb-select>

      <label class="mb-0 mr-2">{{'modules.mission.mission_form.contact_dialog.first_name' | translate}}</label>
      <input nbInput class="mr-2" [(ngModel)]="firstName">

      <label class="mb-0 mr-2">{{'modules.mission.mission_form.contact_dialog.last_name' | translate}}</label>
      <input nbInput class="mr-2" [(ngModel)]="lastName">
    </div>
  </common-card-body>
  <common-card-footer>
    <div class="row">
      <div class="col-12 text-right">
        <button nbButton status="primary" (click)="submit()">
          {{'global.button.submit' | translate}}
        </button>
      </div>
    </div>
  </common-card-footer>
</common-card>
